import { useMemo } from 'react'
import type { LayerProps, SymbolLayer } from 'react-map-gl'
import { PROPERTY_TYPES_COLORS } from '~/constants'

export function useListingPointLayerStyle(props: Partial<SymbolLayer> = {}) {
  const layerCaseStyles = useMemo(() => {
    const cases: any = []
    cases.push(['==', ['get', 'featured'], true], 'featured')

    const types = ['lease', 'sale', 'sale-lease']
    PROPERTY_TYPES_COLORS.forEach(({ value, propertyType }) => {
      types.forEach((type) => {
        cases.push(
          ...[
            [
              'all',
              ['==', ['get', 'imageType'], type],
              ['==', ['get', 'primaryPropertyType'], propertyType],
            ],
            `${value}-${type}`,
          ]
        )
      })
    })
    return cases
  }, [])

  const pointLayer: LayerProps = {
    ...props,
    type: 'symbol',
    layout: {
      'icon-image': [
        'case',
        ...layerCaseStyles,

        // default
        'red-sale-lease',
      ],
      'icon-size': ['case', ['==', ['get', 'featured'], true], 0.2, 0.15],
      'icon-allow-overlap': true,
      'icon-ignore-placement': true,
      'text-allow-overlap': true,
      'text-ignore-placement': true,
    },
  }
  return pointLayer
}
